/* eslint-disable import/prefer-default-export */

export const TABLE_COLUMNS = [
  {
    field: 'name',
    title: 'Company Name',
    sortable: true,
    width: '50%'
  },
  {
    field: 'city',
    title: 'City',
    sortable: false
  },
  {
    field: 'state',
    title: 'State',
    sortable: false
  },
  {
    field: 'actions',
    title: '',
    sortable: false
  }
];
